var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{attrs:{"id":"sidebar"}},[_c('div',{staticClass:"header-container"},[_c('h3',[_vm._v(_vm._s(this.lbl_number_of_commitments))])]),_c('div',{attrs:{"id":"map-data"}},[_c('p',[_vm._v(_vm._s(this.filter_instruction))]),_c('ul',{attrs:{"id":"action-commitments"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }